var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.536 12.342l-.08.31-1.515 5.911h0a.5.5 0 00.765.538l.83-6.759zm0 0l-.248-.202-4.794-3.907h0a.5.5 0 01.316-.887h6.548l.115-.34L10.544.9h0a.5.5 0 01.945-.006h0l2.156 6.118.118.334h6.431a.5.5 0 01.317.888l-4.785 3.907-.247.201.079.31 1.505 5.911a.5.5 0 01-.765.538h0l-5.01-3.41-.28-.19-.282.19-5.02 3.41.83-6.759z",
    stroke: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "star-half_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.63.06h10.35v19.63H.63z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star-half_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.972 12.528L1.178 8.621c-.729-.594-.309-1.775.632-1.775H8L10.071.74c.305-.9 1.575-.907 1.89-.01l2.156 6.117h6.077c.94 0 1.361 1.18.633 1.775l-4.785 3.907 1.506 5.912c.227.893-.77 1.592-1.531 1.074l-5.01-3.409-5.02 3.41c-.762.517-1.76-.184-1.53-1.076l1.515-5.91z",
    fill: "#111"
  }))));
}

var MemoSvgStarHalf = /*#__PURE__*/React.memo(SvgStarHalf);
export default MemoSvgStarHalf;